import { useState, useEffect } from "react"
import API from "../services/ApiService";
import { safeApiCall } from "../utils/safeApiCall";
import { toast } from "react-toastify";

export default function Map({ selectedMap, level, setLevelBoundaries, setAttempt, setAnswers, answers, setJustLoading}) {
    const [mapData, setMapData] = useState(null);

    const loadMap = async(mapName) => {
        const loadedMap = await import(`./maps/${mapName}`);
        return loadedMap.default;
    }

    useEffect(() => {
        if (selectedMap === "") return;
        loadMap(selectedMap).then(data => {
            setMapData({
                ...data,
                map: selectedMap
                });
            const levels = Object.keys(data).map(Number);
            setLevelBoundaries({min: Math.min(...levels), max: Math.max(...levels)});
        });
    }, [selectedMap]);


    const handleClick = async (id) => {
        const res = await safeApiCall(() => API.roomAnswer(Math.floor(id)), null);
        if (!res) {
            toast.error("Error submitting answer");
            return;
        }
        setAttempt(prev => prev + 1);
        setAnswers(prev => [...prev,
            {room: res.data.room,
            map: res.data.map,
            map_name: res.data.map_name,
            level: res.data.level,
            is_correct: res.data.correct_answer,
            room_level: res.data.room_level,
            id: id}]);
        setJustLoading(false);
    }

    const getRoomState = (room) => {
        const answer = answers.find(a => a.id == Math.floor(room.id));
        if (!answer) return null;
        return answer.is_correct ? "correct" : "wrong";
};

    const renderShape = (room) => {
        const attempted = getRoomState(room);
        const fill = attempted ? attempted == "correct" ? "rgba(8, 105, 8, 0.432)" : "rgba(161, 65, 65, 0.62)" : "rgb(139, 131, 131)";

        switch(room.shape){
            case 'rect':
                return (
                    <rect
                        className={`svg-room ${attempted ? "clicked" : ""}`}
                        key={room.id}
                        x={room.x}
                        y={room.y}
                        width={room.width}
                        height={room.height}
                        stroke="rgb(167, 162, 162)"
                        fill={fill}
                        onClick={attempted ? undefined : () => handleClick(room.id)}
                    >
                        <title>{room.name}</title>
                    </rect>
                );
            case "path":
                return (
                    <path
                        className={`svg-room ${attempted ? "clicked" : ""}`}
                        key={room.id}
                        d={room.d}
                        stroke="rgb(167, 162, 162)"
                        fill={fill}
                        onClick={attempted ? undefined : () => handleClick(room.id)}
                    >
                        <title>{room.name}</title>
                    </path>
                );
            case "circle":
                return (
                    <circle
                        className={`svg-room ${attempted ? "clicked" : ""}`}
                        key={room.id}
                        cx={room.cx}
                        cy={room.cy}
                        r={room.r}
                        stroke="rgb(167, 162, 162)"
                        fill={fill}
                        onClick={attempted ? undefined : () => handleClick(room.id)}
                    >
                        <title>{room.name}</title>
                    </circle>
                );
            case "ellipse":
                return (
                    <ellipse
                        className={`svg-room ${attempted ? "clicked" : ""}`}
                        key={room.id}
                        cx={room.cx}
                        cy={room.cy}
                        rx={room.rx}
                        ry={room.ry}
                        stroke="rgb(167, 162, 162)"
                        fill={fill}
                        onClick={attempted ? undefined : () => handleClick(room.id)}
                    >
                        <title>{room.name}</title>
                    </ellipse>
                );
            default:
                return null;
        }
    }

    const outsideClicks = {
        "Willowstreet.js": 12,
        "NellsDinner.js": 154,
        "Bleasdale.js": 25,
        "Grafton.js": 110,
        "Ridgeview.js": 221,
        "Prison.js": 204,
        "PointHope.js": 177,
        "Edgefield.js": 91,
        "TanglewoodOld.js": 238
        };
    const mapLevel = (mapName, level) => {
        const outsideId = outsideClicks[mapName.map];
        const isOutsideClickable = level == 0 && outsideId;

        const handleRectClick = isOutsideClickable
            ? () => handleClick(outsideId)
            : undefined;

        return (
            <svg
            width="1050"
            height="550"
            viewBox="0 0 1050 550"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="svg-map"
            >
            <rect
                x="0"
                y="0"
                width="1050"
                height="550"
                fill="#050608"
                className={`${isOutsideClickable ? "svg-outside" : ""} ${getRoomState({ id: outsideId }) ? "clicked" : ""}`}
                onClick={handleRectClick}
            >
                <title>{isOutsideClickable && !getRoomState({ id: outsideId }) && "Outside"}</title>
            </rect>
            {mapName[level]?.map((room) => renderShape(room))}
            </svg>
        );
        };

    return (
        <div className="map">
            {mapData && mapLevel(mapData, level)}
        </div>
    )
}